import { jsx } from "react/jsx-runtime";
const ArrowIosRight = ({ className = 'tw-text-neutral-light-800', size = 32 })=>/*#__PURE__*/ jsx("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.36 18.768a1 1 0 0 1-.128-1.408L13.698 12 9.232 6.64a1 1 0 0 1 1.536-1.28l5 6a1 1 0 0 1 0 1.28l-5 6a1 1 0 0 1-1.408.128Z",
            fill: "none",
            className: "tw-fill-current"
        })
    });
const ArrowIosRight_ArrowIosRight = ArrowIosRight;
export default ArrowIosRight_ArrowIosRight;
